export default __webpack_public_path__ + "static/media/greenleaf10.0dc3eab6.mov";